var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_s, activeText, attr, filter, filterLabelMap, filterRoot, name, params, sd, undefined) {
if (!( name == 'total' || name == 'for_sale'))
{
buf.push("<div" + (jade.attr("id", "filter-dropdown-" + (name) + "", true, true)) + (jade.cls(['filter-dropdown',( params.has(name) && activeText ) ? 'is-active' : ''], [null,true])) + "><div class=\"filter-nav-main-text\">" + (jade.escape(null == (jade_interp = filterLabelMap[name].label) ? "" : jade_interp)) + "</div><div class=\"filter-nav-active-text\">" + (jade.escape(null == (jade_interp = activeText) ? "" : jade_interp)) + "</div><div class=\"icon-arrow-down\"></div><nav class=\"filter-dropdown-nav\"><a" + (jade.attr("data-attr", name, true, true)) + " data-val=\"\" href=\"\"><span class=\"filter-dropdown-text\">All " + (jade.escape((jade_interp = filterLabelMap[name].plural) == null ? '' : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
// iterate filter
;(function(){
  var $$obj = filter;
  if ('number' == typeof $$obj.length) {

    for (var val = 0, $$l = $$obj.length; val < $$l; val++) {
      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  } else {
    var $$l = 0;
    for (var val in $$obj) {
      $$l++;      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  }
}).call(this);

buf.push("</nav></div>");
}}.call(this,"_s" in locals_for_with?locals_for_with._s:typeof _s!=="undefined"?_s:undefined,"activeText" in locals_for_with?locals_for_with.activeText:typeof activeText!=="undefined"?activeText:undefined,"attr" in locals_for_with?locals_for_with.attr:typeof attr!=="undefined"?attr:undefined,"filter" in locals_for_with?locals_for_with.filter:typeof filter!=="undefined"?filter:undefined,"filterLabelMap" in locals_for_with?locals_for_with.filterLabelMap:typeof filterLabelMap!=="undefined"?filterLabelMap:undefined,"filterRoot" in locals_for_with?locals_for_with.filterRoot:typeof filterRoot!=="undefined"?filterRoot:undefined,"name" in locals_for_with?locals_for_with.name:typeof name!=="undefined"?name:undefined,"params" in locals_for_with?locals_for_with.params:typeof params!=="undefined"?params:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;